angular.module('storefrontApp')

.component('vcProductGridItem', {
    templateUrl: "themes/assets/js/products-list/product-grid-item.tpl.html",
    bindings: {
        product: '=' 
    }
});
